import React, { 
  useEffect, 
  // useState
} from "react";
import useFormWrapper from "utils/custom-hooks/useFormWrapper";
// import { useLookup } from "utils/context/LookupContext";
import SelectField from "controls/global/select-field";
import { showToast } from "controls/global/stewart-toast/showToast";
import { Property } from "entities/UIModel";
import { useSpaceLookup } from "utils/context/SpaceContext";
// import { uniqWith, isEqual, uniqBy } from "lodash";
// import _ from 'lodash';
// import { convertToStringArray } from "utils/shared";
// import { ProductType } from "entities/ApiModel/Space/SpaceAgencyProductStateConfiguration";

interface Props {
  schema: string;
  name: string;
  disabled?: boolean;
  onChange?: () => void;  
}

const PROPERTY_TYPE_MESSAGE = "The Property Type for your Title Search differs from the file Property Type. Please scroll to the top of the file to update.";

const PropertyTypeField = ( {schema, name, disabled, onChange}:Props) => {
  const {setValue, getValues} = useFormWrapper();
  // const [{ propertyTypes }, { getPropertyTypes }] = useLookup();  
  const [{ tsPropertyTypes  }] = useSpaceLookup();
  // const [propertyTypes, setPropertyTypes] = useState<string[]>([]);
 
  // if (
  //   tsAgencyConfig &&
  //   tsAgencyConfig.products &&
  //   tsAgencyConfig.products.length > 0
  // ) {
  //   const productTypes = tsAgencyConfig?.products
  //     ?.find((p) => p.name?.toLowerCase() === "titlesearch")
  //     ?.productTypes; 
    
  //   if (productTypes && productTypes.length > 0) {
  //     const propertyTypes2D = productTypes.map(subArr => subArr.propertyTypes);
  //     console.log("propertyType2D:", propertyTypes2D);

  //     const propertyTypes = _.flatten(propertyTypes2D);
  //     const propertyTypesUnique = _.uniq(propertyTypes!);
  //     console.log("propertyTypesUnique:", propertyTypesUnique);
  //   }
  // }  

  const currentTsPropertyType = getValues(name);

  const handleOnChange = async (e: any, value: any) => {
    setValue("isFileDefault", false);
    setValue(`${schema}.isPropertyTypeCodeDirty`, true);

    const properties: Property[] = getValues("properties");
    const primaryPropertyTypeCode = properties?.[0].propertyType;

    if (value !== primaryPropertyTypeCode) {
      // showFlashMessage(FlashMessageType.Warning, "Warning!", PROPERTY_TYPE_MESSAGE);
      showToast({
        type: 'warning',
        title: 'Warning!',
        message: PROPERTY_TYPE_MESSAGE
      });  
    }

    onChange && onChange();
  };  

  // Get Property Types from Space Config
  // useEffect(()=> {
  //   if (
  //     tsAgencyConfig &&
  //     tsAgencyConfig.products &&
  //     tsAgencyConfig.products.length > 0
  //   ) {
  //     const productTypes = tsAgencyConfig?.products
  //       ?.find((p) => p.name?.toLowerCase() === "titlesearch")
  //       ?.productTypes; 
      
  //     if (productTypes && productTypes.length > 0) {
  //       const propertyTypes2D = productTypes.map(subArr => subArr.propertyTypes);
  //       console.log("propertyType2D:", propertyTypes2D);
  
  //       if (propertyTypes2D) {
  //         const propertyTypes1D = _.flatten(convertToStringArray(propertyTypes2D));
  //         const propertyTypesUnique = _.uniq(propertyTypes1D);
  //         console.log("propertyTypesUnique:", propertyTypesUnique);
  //         setPropertyTypes(propertyTypesUnique);
  //       }
  //     }
  //   }  
  // },[tsAgencyConfig])

  useEffect(() => {
    if (tsPropertyTypes.length > 0) {
      const productID: number = getValues(`${schema}.productID`)
      // const currentTransactionType = getValues(name);
      const properties: Property[] = getValues("properties");
      const primaryPropertyTypeCode = properties?.[0].propertyType;
      const isPropertyTypeCodeDirty: boolean = getValues(
        `${schema}.isPropertyTypeCodeDirty`
      );
      if (!isPropertyTypeCodeDirty && productID === 0) {
        const match = tsPropertyTypes.find((pt) => pt.value === primaryPropertyTypeCode);
        if (match) {
          setValue(name, match.value);
        }
      }
    }
  },[tsPropertyTypes, currentTsPropertyType]) 

  // Get Property Types from SC 
  // useEffect(function fetchSelectOptions() {
  //   if (propertyTypes.length === 0) getPropertyTypes();
  // }, [propertyTypes, getPropertyTypes]);

  // console.log("propertyTypes:", propertyTypes);
  return (
    <SelectField
      label="Property Type"
      name={name}
      options={tsPropertyTypes}
      disabled={disabled}
      onChange={handleOnChange}
    />
  );
}

export default PropertyTypeField;